import { Injectable } from '@angular/core';
import { HttpModule, RequestOptions, Headers, Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthenticationService } from './authentication.service';
import { Configuration } from '../../app.constants';

@Injectable()
export class FileUploadService {
  FILES_ENDPOINT = this._configuration.apiUrl + '/v2/upload';

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  upload(file: File) {
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);

    var headers = new Headers(this._authService.getHeaders());
    //headers.append('Accept', 'application/json');
    
    return this._http.post(this.FILES_ENDPOINT, formData, { headers: headers })
      .map(response => response.json())
      .catch(error => Observable.throw(error));
  }

}





// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/file-upload.service.ts